import { ParentLogin } from '@/features/auth'

export function LoginPage() {
  return <ParentLogin />
}
